import React, { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { LockIcon, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import { useAuth } from "~/hooks/use-auth";
import { Button } from "../ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  useForm,
} from "../ui/form";
import { Input } from "../ui/input";

export default function LoginForm() {
  const { signIn } = useAuth();

  const navigate = useNavigate();

  const { t } = useTranslation("common");

  const form = useForm({
    schema: z.object({
      email: z.string().email(),
      password: z.string().min(1),
    }),
  });

  const [signingIn, setSigningIn] = useState(false);
  const handleLogin = form.handleSubmit(async (data) => {
    setSigningIn(true);
    const result = await signIn(data);
    if (typeof result === "boolean") {
      if (result === true) {
        await navigate({ to: "/" });
      }
    } else {
      form.setError("root", { message: result.message });
    }
    setSigningIn(false);
  });
  return (
    <Form {...form}>
      <form onSubmit={handleLogin} className="flex flex-col gap-2">
        <FormField
          disabled={signingIn}
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  icon={<Mail size={16} />}
                  type="email"
                  placeholder={t("email_placeholder")}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          disabled={signingIn}
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  icon={<LockIcon size={16} />}
                  type="password"
                  placeholder={t("password_placeholder")}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        {form.formState.errors.root && (
          <FormMessage>{form.formState.errors.root.message}</FormMessage>
        )}
        <Button variant="brand" type="submit" disabled={signingIn}>
          {t("sign_in")}
        </Button>
      </form>
    </Form>
  );
}
